import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main_div" }
const _hoisted_2 = { style: {"height":"auto"} }

import { ref, watch, onMounted } from "vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue3-quill";
import { getCallable } from "@/config/env";
import {
    NRadio,
    NCheckbox,
    NSpace,
    NCard,
    NSelect,
    NButton,
    NInput,
    NModal,
    NRadioGroup,
    NUpload,
    useMessage,
    useNotification,
    useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";

import { Board } from "@/model/board";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddQna',
  props: {
    isAddQna: { type: Boolean },
    selectedItem: {}
  },
  emits: ["hide"],
  setup(__props: any, { emit: __emit }) {

const addQnaCallable = getCallable("addBoard");

const props = __props;
const emit = __emit;
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();
const isLoading = ref<boolean>(false);
const error = ref<string | null>(null);
const submitButtonText = ref<string | null>(null);
const contentOrderNumber = ref<number>(1);
const contentQuestion = ref<string | null>(null);
const contentAnswer = ref<string>("");
const isAlert = ref<boolean>(false);
const alertMessage = ref<string | null>(null);
const alertType = ref<string | null>(null);
const editorReady = ref(false); // 에디터 준비 상태를 위한 ref
const editorOption = ref({
    modules: {
        toolbar: [
            ["bold", "italic", "underline", "strike"], // 굵게, 기울임, 밑줄, 취소선
            ["blockquote", "code-block"], // 인용구, 코드 블록
            [{ header: 1 }, { header: 2 }], // 제목 크기
            [{ list: "ordered" }, { list: "bullet" }], // 순서 있는 목록, 순서 없는 목록
            [{ script: "sub" }, { script: "super" }], // 아래 첨자, 위 첨자
            [{ indent: "-1" }, { indent: "+1" }], // 들여쓰기
            [{ direction: "rtl" }], // 글쓰기 방향
            [{ size: ["small", false, "large", "huge"] }], // 글자 크기
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // 글자색, 배경색
            [{ font: [] }],
            [{ align: [] }],
            ["clean"], // 서식 지우기
        ],
    },
    placeholder: "여기에 내용을 입력하세요...", // placeholder도 options 객체로 설정 가능
    theme: "snow", // 테마도 여기서 설정 가능
});
onMounted(() => {
    editorReady.value = true; // 컴포넌트가 마운트된 후 editorReady를 true로 설정
});
watch(
    () => props.isAddQna,
    (newIsAddQna: boolean) => {
        submitButtonText.value = "등록";
        clearEditor();
    }
);
function onBlur(quill: any) {
    // console.log("editor blur!", quill);
}
function onFocus(quill: any) {
    // console.log("editor focus!", quill);
}
function onChange(quill: any) {
    // console.log("editor change!", quill);
}
function onReady(quill: any) {
    // console.log("editor ready!", quill);
}
function clearEditor() {
    contentQuestion.value = "";
    contentAnswer.value = "";
}

function onPositiveClick() {
    isAlert.value = false;
}

function checkAddQna() {
    alertType.value = "error";
    isAlert.value = true;
    if (!contentQuestion.value) {
        alertMessage.value = "질문을 입력해주세요.";
        return;
    } else if (!contentAnswer.value) {
        alertMessage.value = "질문을 입력해주세요.";
    } else if (!contentOrderNumber.value) {
        alertMessage.value = "질문을 입력해주세요.";
    } else {
        alertType.value = "";
        isAlert.value = false;
        addQnaItem();
    }
}

async function addQnaItem() {
    isLoading.value = true;

    try {
        const result = await addQnaCallable({
            boardType: constant.boardType.QNA,
            boardData: {
                order_num: contentOrderNumber.value,
                question: contentQuestion.value,
                answer: contentAnswer.value,
                author: "(주)COKO Lab.",
            },
        });
        if (common.evalFunctionResult(result)) {
            message.success("FAQ 등록 성공!");
            hide();
        } else {
            notification.error({
                title: "에러",
                description: `FAQ 등록 실패: ${common.getResultError(result) || "오류가 발생했습니다."}`,
                duration: 1500,
                closable: true,
            });
        }
    } catch (error) {
        notification.error({
            title: "에러",
            description: `FAQ 등록 실패: ${error || "오류가 발생했습니다."}`,
            duration: 1500,
            closable: true,
        });
    } finally {
        isLoading.value = false;
    }
}
function hide() {
    emit("hide");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(Loading, null, null, 512), [
        [_vShow, isLoading.value]
      ]),
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"250px","font-weight":"bold"} }, "FAQ 관리 > FAQ 등록", -1)
                ])),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(NSpace), { style: {"width":"1400px","min-width":"1400px","height":"auto"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"100px","width":"1400px","min-width":"1400px","height":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), { "item-style": "display: flex;" }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "순서", -1)),
                  _createVNode(_unref(NInput), {
                    type: "number",
                    placeholder: "순서",
                    value: contentOrderNumber.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((contentOrderNumber).value = $event)),
                    style: {"width":"100px","height":"30px","text-align":"left"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "add_content_delimiter_line" }, null, -1)),
              _createVNode(_unref(NSpace), { "item-style": "display: flex;" }, {
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "질문", -1)),
                  _createVNode(_unref(NInput), {
                    type: "text",
                    placeholder: "",
                    value: contentQuestion.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((contentQuestion).value = $event)),
                    style: {"width":"1000px","height":"30px","text-align":"left"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "add_content_delimiter_line" }, null, -1)),
              _createVNode(_unref(NSpace), null, {
                default: _withCtx(() => [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "답변", -1)),
                  (editorReady.value)
                    ? (_openBlock(), _createBlock(_unref(quillEditor), {
                        key: 0,
                        value: contentAnswer.value,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((contentAnswer).value = $event)),
                        options: editorOption.value,
                        theme: "snow",
                        onBlur: onBlur,
                        onFocus: onFocus,
                        onChange: onChange,
                        onReady: onReady,
                        style: {"width":"auto","height":"450px"}
                      }, null, 8, ["value", "options"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "add_content_delimiter_line" }, null, -1)),
              _createVNode(_unref(NSpace), {
                style: {"margin-top":"50px"},
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NButton), {
                    dashed: "",
                    style: {"width":"250px","height":"30px","border":"none"},
                    type: "warning",
                    onClick: hide
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" 취소 ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(NButton), {
                    dashed: "",
                    style: {"width":"250px","height":"30px","border":"none"},
                    type: "success",
                    onClick: checkAddQna
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(submitButtonText.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(NModal), {
      show: isAlert.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((isAlert).value = $event)),
      "mask-closable": false,
      content: alertMessage.value,
      type: alertType.value,
      preset: "dialog",
      title: "Dialog",
      "positive-text": "확인",
      onPositiveClick: onPositiveClick
    }, null, 8, ["show", "content", "type"])
  ]))
}
}

})